import { CommonGAssets } from '@hhgtech/hhg-components/gAssets'
import { Text } from '@hhgtech/hhg-components/mantine'
import { BoxProps, Stack } from '@mantine/core'
import { useIntl } from 'react-intl'

import useStyles from './index.styles'
import { Layout } from '../Layout'
import { LocationSelector } from '../LocationSelector'

type Props = {
  message: string
} & BoxProps

export const ErrorScreenNotFoundResult = ({
  styles,
  classNames,
  message,
  ...props
}: Props) => {
  const { formatMessage: f } = useIntl()
  const { classes } = useStyles(undefined, {
    name: 'AirPopulation__ErrorScreenNotFoundResult',
    styles,
    classNames,
  })

  return (
    <Layout
      {...props}
      classNames={{
        root: classes.root,
        colLeft: classes.colLeft,
        colRight: classes.colRight,
      }}
      colLeft={
        <Stack spacing={16} className={classes.info}>
          <Stack spacing={2} className={classes.selector}>
            <LocationSelector />
            <Text size="p3" variant="error">
              {f({
                id: 'airPopulation.notFoundResult.error',
                defaultMessage: 'Please reselect location',
              })}
            </Text>
          </Stack>
          <Text size="p2" variant="secondary" className={classes.desc}>
            {message ||
              f({
                id: 'airPopulation.notFoundResult.description',
                defaultMessage:
                  'Looks like there was an issue with your selected location. Try selecting it again!',
              })}
          </Text>
        </Stack>
      }
      colRight={
        <img
          loading="lazy"
          alt="Result not found"
          width={120}
          height={120}
          src={CommonGAssets.getAssetPath('airPopulation/result-not-found.svg')}
        />
      }
    />
  )
}
